export default async (allAssets, reqArr) => {
    const curArr = Object.keys(allAssets)
    const missingArr = [];

    for (let item of reqArr) {
        item = item.toUpperCase()
        if ( !curArr.includes(item) ) missingArr.push(item)
    }

    if (!missingArr.length) return

    const dataJSON = await fetch(`/api/get-coins-data?assets=${missingArr.toString()}`)
    const data = await dataJSON.json()
    const keys = Object.keys(data)

    for (let key of keys) {
        allAssets[key] = data[key]
    }
}